import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';

import { EmbeddedContainer } from '../../../components/Containers/DrawerContainer/EmbeddedContainer';
import {
  ProductStoryblok,
  ProductV2Storyblok,
} from '../../../types/generated-storyblok';
import { ProductPurchaseDetails } from '../../../types/Purchasing';
import { EnquiryProduct } from './EnquiryProduct';

type Props = {
  onClose?: () => void;
  product?: ProductStoryblok | ProductV2Storyblok;
  productPrice?: number;
  productPurchaseDetails?: ProductPurchaseDetails;
  thumbnail: {
    filename: string;
    focus: string;
  };
};

export const EnquirySuccessScreen: React.FC<Props> = ({
  onClose,
  product,
  productPrice,
  productPurchaseDetails,
  thumbnail,
}) => {
  const { t } = useTranslation('enquiries');

  return (
    <EmbeddedContainer embedded>
      <div className="space-y-6">
        <div className="w-full">
          <p className="text-md font-bold md:text-lg">
            {t('drawers.successScreen.title')}
          </p>
        </div>

        {product && productPrice && productPurchaseDetails && (
          <div className="flex w-full flex-col space-y-3">
            <EnquiryProduct
              product={product as unknown as ProductType}
              productPrice={productPrice}
              productPurchaseDetails={productPurchaseDetails}
              state="SENT"
              thumbnail={thumbnail}
            />
          </div>
        )}

        <div className="w-full">
          <Button
            fullWidth
            label={t('drawers.successScreen.back')}
            onClick={() => {
              onClose?.();
            }}
            variant="secondary"
          />
        </div>
      </div>
    </EmbeddedContainer>
  );
};
